import actionTypes from "../actionTypes"

const updateShowPremiumActions = data => {
  return {
    type: actionTypes.SET_SHOW_PREMIUM_ACTIONS,
    payload: data,
  }
}

export default {
  updateShowPremiumActions,
}